import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import ptCommon from './locales/pt/common.json';

/**
 * i18n Configuration
 * 
 * Internationalization setup for the ALZ Token Portal
 * Supports Portuguese (pt-BR) and English (en-US)
 */

const resources = {
  en: {
    common: enCommon,
  },
  pt: {
    common: ptCommon,
  },
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    
    // Language settings
    fallbackLng: 'pt', // Default to Portuguese for Brazilian market
    debug: import.meta.env.DEV, // Enable debug in development
    
    // Namespace settings
    defaultNS: 'common',
    ns: ['common'],
    
    // Detection settings
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'alz-language',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Load translations immediately
    load: 'languageOnly', // Load only language without region (pt instead of pt-BR)
    
    // Fallback behavior
    saveMissing: false,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation: ${lng}.${ns}.${key}`);
    },
  });

export default i18n;